import React, { useState } from 'react'
import ReviewStep from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/ReviewStep'
import { SongwriterUpdateRequestFormData } from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar'
import EditWriterName from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/WriterMisspellingForm/EditWriterName'

interface WriterMisspellingFormProps {
    onBack(): void
    onSubmit(formData: SongwriterUpdateRequestFormData): void
    selectedWriterName: string
}

const WriterMisspellingForm = (props: WriterMisspellingFormProps) => {
    const { onBack, onSubmit, selectedWriterName } = props
    const [misspelling, setMisspelling] = useState<SongwriterUpdateRequestFormData>({
        correctSpelling: '',
        reasonForCorrection: '',
    })
    const [isReviewing, setIsReviewing] = useState<boolean>(false)

    return (
        <>
            {!isReviewing ? (
                <EditWriterName
                    onBack={onBack}
                    setIsReviewing={(newIsReviewing) => setIsReviewing(newIsReviewing)}
                    misspelling={misspelling}
                    setMisspelling={(newMisspelling) => setMisspelling(newMisspelling)}
                />
            ) : (
                <ReviewStep
                    header="Edit Writer Name"
                    onBack={() => setIsReviewing(false)}
                    onSubmit={() => onSubmit(misspelling)}
                    selectedWriterName={selectedWriterName}
                >
                    <div>
                        <p>Suggested Correction: </p>
                        <p>
                            <b>{misspelling.correctSpelling}</b>
                        </p>
                    </div>
                    <div>
                        <p>Reason for Correction </p>
                        <p>
                            <b>{misspelling.reasonForCorrection}</b>
                        </p>
                    </div>
                </ReviewStep>
            )}
        </>
    )
}
export default WriterMisspellingForm
